import { render, staticRenderFns } from "./SelectFaculty.vue?vue&type=template&id=a9e2f9da&scoped=true"
import script from "./SelectFaculty.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectFaculty.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e2f9da",
  null
  
)

export default component.exports